<div mat-dialog-title class="change-site-state">
  Select E-Doc Template
  <div class="close-icon-container" (click)="onNoClick()">
    <fa-icon [icon]="['far', 'xmark']" class="gray"></fa-icon>
  </div>
</div>
<mat-divider></mat-divider>
<div mat-dialog-content>
  <p>Please select a template to be sent to the landowner and their delegate.</p>
  <form [formGroup]="selectEdocTemplateForm" class="site-form">
    <mat-select class="doc-type-select" formControlName="templateId" placeholder="Docusign Template">
      <mat-option *ngFor="let template of templates" [value]="template.templateId">
        {{ template.description }}
      </mat-option>
    </mat-select>
  </form>
</div>
<div mat-dialog-actions>
  <button
    data-cy="button-yes"
    mat-raised-button
    color="primary"
    [disabled]="!this.selectEdocTemplateForm.valid"
    class="green-shadow-button"
    (click)="onSubmit()">
    Send Docusign
  </button>
</div>
